import gql from "graphql-tag";

export const GET_APP_VERSION = gql`
  query getAppVersion($clientVersion: String) {
    appVersion(clientVersion: $clientVersion)
  }
`;
